if (!customElements.get('luma-product-edit')) customElements.define('luma-product-edit', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-edit-group]');
      if (!button) return;
      this.querySelectorAll('[data-edit-group]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      let count = 0;
      this.querySelectorAll('[data-edit-card]').forEach(card => {
        card.hidden = card.dataset.editCard !== button.dataset.editGroup;
        if (!card.hidden) count++;
      });
      const status = this.querySelector('[data-edit-status]');
      status.textContent = count + ' ' + status.dataset.message;
    });
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const family = new URLSearchParams(location.search).get('family');
  if (['fresh', 'floral', 'warm', 'woody'].includes(family)) document.querySelector('luma-scent-finder [data-family="' + family + '"]')?.click();
});
